import React from 'react';
import { Card } from 'primereact/card';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import MultiDemandDetail from '@components/pages/admin/carriers/MultiDemandDetail';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const MultiDemandDetailPage: React.FC<ComponentProps> = () => {
  const { t } = useTranslation('common');

  const { id } = useParams();

  return (
    <ResponsiveLayout title={t(`MultiDemandDetail.title`, `Multi demands detail`)}>
      {/*// @ts-ignore*/}
      <Card>
        <MultiDemandDetail id={id} />
      </Card>
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(MultiDemandDetailPage);
